var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrimaryEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8835 4.1001L13.3735 1.6001L3.33313 11.6001L2.3291 15.1001L5.84322 14.1001L15.8835 4.1001ZM11.3654 3.6001L13.8755 6.1001L11.3654 3.6001ZM3.33313 11.6001L5.84322 14.1001L3.33313 11.6001Z",
    stroke: "#2148C0",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.0645,
    height: 16,
    fill: "white",
    transform: "translate(0.722656)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryEdit);
export default __webpack_public_path__ + "static/media/primaryEdit.548abaa622888406f01f19d78ea12218.svg";
export { ForwardRef as ReactComponent };